import { CSSProperties } from 'react';

import UIConfig from '@/UIConfig.ts';

export const imageStyles: CSSProperties = {
  maxWidth: '90%',
  borderRadius: '10px',
  marginBottom: '20px'
};

export const overlayStyles: CSSProperties = {
  backgroundColor: UIConfig.Colors.BackgroundWhite,
  width: '100%',
  height: '100%',
  borderRadius: '10px',
  position: 'absolute',
  top: 0,
  left: 0,
  zIndex: 2,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};
export const buttonContainerStyles: CSSProperties = {
  minWidth: '40%',
  maxWidth: '50%',
  height: '45px',
  color: 'black',
  background: 'white',
  border: '1px solid black',
  borderRadius: '45px',
  fontSize: '14px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  outline: 'none',
  textAlign: 'center',
  fontWeight: 300,
  cursor: 'pointer'
};

export const contentStyles: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px'
};

export const videoContainerStyles: CSSProperties = {
  position: 'relative',
  textAlign: 'center',
  borderRadius: '10px',
  width: '100%',
  height: '70vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};

export const videoElementStyles: CSSProperties = {
  width: '100%',
  height: '100%',
  backgroundColor: 'black',
  borderRadius: '10px',
  objectFit: 'cover',
  maxWidth: '100%',
  maxHeight: '100%'
};
